import React from 'react';
import {
  SiteHeader,
  SiteFooter,
} from '~/components';

const SiteLayout = React.forwardRef(({ isHomePage, children }, ref) => (
  <div className="l-container">
    <SiteHeader isHomePage={isHomePage} />
    {children}
    <SiteFooter isHomePage={isHomePage} ref={ref} />
  </div>
)
);

export default React.memo(SiteLayout);